import { createSlice, PayloadAction, SerializedError } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

interface ErrorState {
  message: string | null
}

const initialState: ErrorState = {
  message: null,
};

class CustomError extends Error {
  code?: string;

  constructor(
    name ?: string,
    message ?: string,
    code ?: string,
    stack ?: string,
  ) {
    super(message);
    this.name = name || "CustomError";
    this.stack = stack || new Error().stack;
    this.message = message || "no error message defined";
    this.code = code;
  }
}

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setErrorMessage: (state, error: PayloadAction<any>) => {
        if (error instanceof AxiosError) {
            const code = Number(error?.status);
            state.message = codeMessage(code)
        } else if (error instanceof Error) {
            console.error(error);
            state.message = error.message
        } else if (error instanceof CustomError) {
            const code = Number(error?.code);
            state.message = codeMessage(code)
        } else {
            console.error(error);
        }
    },
  }
})

export const { setErrorMessage } = errorSlice.actions;
export default errorSlice.reducer;

const codeMessage = (code: number): string | null => {
    switch(code) {
    case 404:
        // no courses, users or groups found, which is allowed because it happens often when creating new clients
        return null;
    case 401:
        return "Error in user authentication, please contact tech@pacy.ai"
    case 403:
        return "User is not authorized to fetch content, please contact tech@pacy.ai"
    default:
        return "An error occurred while fetching data."
    }
}